import RoleOverviewContent from "./RoleOverviewContent";
import CongratulationsContent from "./CongratulationsContent";

const wizardContentData = {
    RoleOverviewContent,
    CongratulationsContent
};

export default wizardContentData;
